module.exports = __webpack_public_path__ + "img/pin-in-0.cd083868.svg";